import { render, staticRenderFns } from "./TrangDanhSachLog.vue?vue&type=template&id=1108174c&"
import script from "./TrangDanhSachLog.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports